module.exports = __webpack_public_path__ + "media/images/canv-signup-new_logo-f090866b.jpg";